module.exports = __webpack_public_path__ + "static/media/drumnow-4.32fced9c.jpg";